﻿import * as pageHelper from "./pageHelper";

export default class Image {

    constructor() {
        this.SavedViewOption = "";                 // used to save image view option selected by user; the screen option resets to default/gallery as we move between records
        this.parentPage = null;
        this.container = null;
        this.hasViewScreen = true;
    }

    initializeImage = (parentPage) => {
        this.parentPage = parentPage;          // save the parent page
        this.container = $(`#${parentPage.detailContentContainer}`);
        
        this.container.find("#UploadZone").hide();

        if (this.SavedViewOption === "")
            this.SavedViewOption = this.GetScreenViewOption();

        this.refreshDisplay();

        this.container.find('input[name="ImageViewOption"]').change((e) => {
            this.SavedViewOption = $(e.target).val();
            this.refreshDisplay();
        });

        // _ImageGallery.cshtml button events
        const galleryViewButtons = this.container.find("#imageListButtonsContainer");
        galleryViewButtons.find("#view").click((e)=> {
            e.preventDefault();
            const selectedImage = this.getSelected();
            this.view(selectedImage);
        });

        galleryViewButtons.find("#add").click((e)=> {
            e.preventDefault();
            this.add();
        });

        galleryViewButtons.find("#edit").click((e)=> {
            e.preventDefault();
            const selectedImage = this.getSelected();
            this.edit(selectedImage);
        });

        galleryViewButtons.find("#delete").click((e)=> {
            e.preventDefault();
            const selectedImage = this.getSelected();
            this.kendoListViewDeleteImage(selectedImage);
        });

        
    }

    // _ImageGrid.cshtml events
    addImage=()=> {
        this.add();
    }

    viewImage = (e, grid) => {
        const selectedImage = grid.dataItem($(e.currentTarget).closest("tr"));
        this.view(selectedImage);
    }

    editImage = (e, grid) => {
        const selectedImage = grid.dataItem($(e.currentTarget).closest("tr"));
        this.edit(selectedImage);
    }

    checkoutImage = (e, grid) => {
        let row = $(e.currentTarget).closest("tr");
        const selectedImage = grid.dataItem(row);
        const checkoutUrl = row.find(".k-grid-Checkout").data("url");

        this.checkout(selectedImage, checkoutUrl);
    }

    deleteImage=(e, grid)=> {
        e.preventDefault();
        const selectedImage = grid.dataItem($(e.currentTarget).closest("tr"));
        this.kendoGridDeleteImage(e, selectedImage);
    }

    downloadImage = (parentId, gridName,url) => {
        const grid = $(gridName).data("kendoGrid");
        const selection = grid.selectedKeyNames();
        
        if (selection.length > 0) {
            let downloadForm = $("#documentsDownload").last();
            if (downloadForm.length > 0) {
                downloadForm.remove();    
            }
            $(`<form action="${url}" method="post" id="documentsDownload"><input type="hidden" name="ParentId" value="${parentId}"/><input type="hidden" name="Selection" value="${selection.join()}"/></form>`).appendTo('body').submit();
        }
    }

    GetScreenViewOption=()=> {
        const viewOptions = this.container.find('input[name="ImageViewOption"]');
        return viewOptions.val();
    }

    configureEditor=(action)=> {
        if (action === "edit") {
            const selectedImage = this.getSelected();
           
            if (selectedImage.ThumbnailFile && selectedImage.ThumbnailFile.includes("url")) {
                const imageFile = this.container.find('#ImageFile').val();
                this.container.find('#Url').val(imageFile);
                this.container.find('[name="uploadAction"]').removeAttr('checked');
                this.container.find('input:radio[name="uploadAction"][value="url"]').attr('checked', true);
            }
        }

        //default Public Access to check if RestrictPrivateDocument is enabled
        const isPublic = this.container.find('input:checkbox[name="IsPublic"]');
        if (isPublic.is(":visible")) {
            isPublic.attr('checked', true);
        }

        const value = this.container.find("input[name=uploadAction]:checked").val();
        this.configureEditorRows(value);
    }

    configureEditorRows=(currentValue)=> {
        const uploadActionContainer = this.container.find("#uploadActionContainer");
        uploadActionContainer.find("input:radio").each(function () {
            const value = $(this).val();
            const selector = "#" + value + "Row";
            if (value === currentValue) {
                $(selector).show();
            }
            else {
                $(selector).hide();
            }
        });

    }

    configureListButtons=()=> {
        const dataSource = this.container.find(".imageListView").data("kendoListView").dataSource;
        dataSource.fetch(()=> {
            this.showListButtons(dataSource.total() > 0);
        });
    }

    showListButtons=(showButtons)=> {
        const listViewButtons = this.container.find("#imageListButtonsContainer");
        
        if (showButtons) {
            listViewButtons.find("#view").show();
            listViewButtons.find("#edit").show();
            listViewButtons.find("#delete").show();
        }
        else {
            listViewButtons.find("#view").hide();
            listViewButtons.find("#edit").hide();
            listViewButtons.find("#delete").hide();
        }
    }

    refreshDisplay = (isUpdateRecordStamps) => {
        
        if (!this.hasViewScreen) //when image upload is from screen like QD
            return;

        const screenOption = this.GetScreenViewOption();

        if (this.SavedViewOption === "GalleryView") {
            this.refreshListView();
            this.container.find("#imageGalleryContainer").show();
            this.container.find("#imageGridContainer").hide();
            if (screenOption !== this.SavedViewOption)
                this.container.find("#ImageGalleryView").prop("checked", true);
        }
        else {
            this.refreshGrid();
            this.container.find("#imageGridContainer").show();
            this.container.find("#imageGalleryContainer").hide();
            if (screenOption !== this.SavedViewOption)
                this.container.find("#ImageGridView").prop("checked", true);
        }
        if (isUpdateRecordStamps !== undefined && isUpdateRecordStamps) {
            pageHelper.updateRecordStamps(this.parentPage);                              // refresh parent stamps on screen
            this.refreshDefaultImage(this.parentPage);
        }


    }

    refreshDefaultImage=(parentPage)=> {
        if (parentPage.defaultImageUrl) {
            $.get(parentPage.defaultImageUrl.replace('amp;','')).done((response)=> {
                const imageContainer = this.container.find(".default-image-container");
                $(imageContainer).html(response);
            });
        }
    }

    refreshGrid=()=> {
        const grid = this.container.find(".imageGridView");
        if (grid.length > 0)
            grid.data("kendoGrid").dataSource.read();
    }

    refreshListView=()=> {
        const dataSource = this.container.find(".imageListView").data("kendoListView").dataSource;
        dataSource.fetch(()=> {
            this.showListButtons(dataSource.total() > 0);
        });
    }


    // on gallery view data-bound, select first image
    onDataBound(e) {
        // automatically select first image
        const listView = e.sender;
        const firstImage = listView.element.children().first();
        listView.select(firstImage);
    }


    // Drag and Drop Events
    onUploadAsyncFail(e) {
        let error = e.XMLHttpRequest.responseText;
        if (error === "")
            error = "Error occurred during upload.";
        alert(error);
    }

    onUploadAsyncSuccess=(e)=> {
        this.refreshDisplay(true);
    }

    showErrors = function (errors) {
        pageHelper.showErrors(errors);
        //const errorSummary = $(document).find(pageHelper.errorSummary);
        //if (errorSummary) {
        //    console.log(errorSummary, errors);
        //    const errorContainer = $(errorSummary).find(".content");
        //    errorContainer.empty();
        //    errorSummary.removeClass("d-none");
        //    if (typeof (errors) === "string") {
        //        errorContainer.html(errors);
        //    }
        //    else {
        //        let errorMsgs = "";
        //        for (const key in errors) {
        //            errorMsgs = errorMsgs + errors[key] + "<br>";
        //        }
        //        errorContainer.html(errorMsgs);
        //    }
        //}
    }

    hideErrors = function () {
        // todo: refactor in the future

        const errorSummary = $(pageHelper.errorSummary);
        const errorContainer = $(errorSummary).find(".content");
        errorContainer.empty();
        errorSummary.addClass("d-none");
    }


    contextMenuOnOpen(e) {

        const items = [{
            text: "<span class='fal fa-search fa-fixed-width'></span>View",
            attr: { "data-action": "view" },
            encoded: false
        }];

        items.push({
            text: "<span class='fal fa-file-plus fa-fixed-width'></span>Add",
            attr: { "data-action": "add" },
            encoded: false
        });

        items.push({
            text: "<span class='fal fa-file-edit fa-fixed-width'></span>Edit",
            attr: { "data-action": "edit" },
            encoded: false
        });

        items.push({
            text: "<span class='fal fa-file-times fa-fixed-width'></span>Delete",
            attr: { "data-action": "delete" },
            encoded: false
        });

        this.setOptions({
            dataSource: items
        });

    }

    contextMenuOnSelect = (e)=> {
        const selectedImage = this.getSelected();
        const selected = $(e.item);
        const action = selected.data("action");

        switch (action) {
            case "view":
                this.view(selectedImage);
                break;

            case "add":
                this.add();
                break;

            case "edit":
                this.edit(selectedImage);
                break;

            case "delete":
                e.preventDefault();
                this.kendoListViewDeleteImage(selectedImage);
                break;
        }
    }

    view = (dataItem) => {
        const listViewButtons = this.container.find("#imageListButtonsContainer");
        const button = listViewButtons.find("#view");
        const imageName = dataItem.ImageFile;

        // filter out url/links
        if (imageName.startsWith("www") || imageName.startsWith("http") || imageName.startsWith("ftp") || imageName.startsWith("file")) {
            window.open(imageName, '_blank');
            return;
        }

        const url = button.attr('data-viewer-url') + "&imageFile=" + imageName + "&screenCode=" + dataItem.ScreenCode + "&key=" + dataItem.ParentId;
        documentPage.zoomDocument(url);
    }
    
    add = ()=> {
        const grid = this.container.find(".imageGridView").data("kendoGrid");
        const url = grid.dataSource.transport.options.create.url;

        this.openPopEditor(url);
    }

    edit= (dataItem) =>{
        const grid = this.container.find(".imageGridView").data("kendoGrid");
        let url = grid.dataSource.transport.options.update.url;
        url = url + "?parentId=" + dataItem.ParentId + "&id=" + dataItem.ImageId + "&screenCode=" + dataItem.ScreenCode;
        this.openPopEditor(url);
    }

    checkout = (dataItem, checkoutUrl) => {
        let url = checkoutUrl;
        url = url.replace("ImageCheckout", "ImageIsLocked");
        url = url + "?parentId=" + dataItem.ParentId + "&id=" + dataItem.ImageId + "&screenCode=" + dataItem.ScreenCode;
        $.get(url).done(function () {
            let checkoutForm = $("#documentCheckout").last();
            if (checkoutForm.length > 0) {
                checkoutForm.remove();
            }
            $(`<form action="${checkoutUrl}" method="post" id="documentCheckout"><input type="hidden" name="ParentId" value="${dataItem.ParentId}"/><input type="hidden" name="id" value="${dataItem.ImageId}"/><input type="hidden" name="screenCode" value="${dataItem.ScreenCode}"/></form>`).appendTo('body').submit();
        })
        .fail((e) => { this.showErrors(e.responseText) });
    }

    // delete from gallery view
    kendoListViewDeleteImage=(dataItem)=> {
        const listView = this.container.find(".imageListView").data("kendoListView");
        if (confirm("Are you sure you want to delete this record?")) {
            $.ajax({
                url: listView.dataSource.transport.options.destroy.url,
                data: { deleted: pageHelper.getKendoDataItemProperties(dataItem) },
                type: "POST",
                success: ()=> {
                    listView.dataSource.remove(dataItem);
                    this.hideErrors();
                    this.configureListButtons();
                    this.refreshDisplay(true);
                },
                error:  (e)=> {
                    this.showErrors(e.responseText);
                }
            });
        }
    }

    kendoGridDeleteImage=(e, dataItem)=> {
        const grid = this.container.find("#" + e.delegateTarget.id).data("kendoGrid");
        const deletePrompt = grid.options.editable.confirmDelete;
        if (confirm(deletePrompt)) {
            $.ajax({
                url: grid.dataSource.transport.options.destroy.url,
                data: { deleted: pageHelper.getKendoDataItemProperties(dataItem) },
                type: "POST",
                success: ()=> {
                    grid.removeRow($(e.currentTarget).closest("tr"));
                    grid.dataSource._destroyed = [];
                    this.hideErrors();
                    this.refreshDisplay(true);
                },
                error: (e)=> {
                    this.showErrors(e.responseText);
                }
            });
        }
    }

    openPopEditor=(url)=> {
        $.get(url)
            .done((result) => {
                //clear all existing hidden popups to avoid kendo id issue
                $(".cpiContainerPopup").empty();

                const popupContainer = this.container.find(".cpiContainerPopup").last();
                popupContainer.html(result);
                this.initializeEditor();

                if (url.includes("ImageUpdate"))
                    this.configureEditor("edit");
                else
                    this.configureEditor("add");
            })
            .fail( (e)=> {
                this.showErrors(e.responseText);
            });
    }

    initializeEditor = () => {
        this.container.find("#imageEditorDialog").modal("show");

        // configure radio button
        this.container.find('input[name="uploadAction"]:radio').on('click', (e)=> {
            this.configureEditorRows(e.currentTarget.id);
        });

        // configure form submit logic
        this.container.find("#imageEditorForm").submit((e)=> {
            e.preventDefault();
            if (!this.validateUploadAction())
                return;
            
            var form = $("#imageEditorForm");
            var formData = new FormData(form[0]);
            $.ajax({
                type: "POST",
                url: form.attr("action"),
                data: formData,
                contentType: false, // needed for file upload
                processData: false, // needed for file upload
                success: (result)=> {
                    this.refreshDisplay(true);
                    $("#imageEditorDialog").modal("hide");
                },
                error: function (e) {
                    pageHelper.showErrors(e);

                    //if (e.responseJSON !== undefined)
                    //    pageHelper.showErrors(e.responseJSON);
                    //else
                    //    pageHelper.showErrors(e.responseText);
                }
            });
        });
    }

    getSelected=()=> {
        const listView = this.container.find(".imageListView").data("kendoListView");
        const index = listView.select().index();
        const dataItem = listView.dataSource.view()[index];
       
        return dataItem;
    }

    validateUploadAction=()=> {
        const isInsertAction = ()=> {
            const el = this.container.find("#ImageId");
            const id = el.val();

            if (id === 0)
                return true;
            else
                return false;
        };

        const isEmpty = (name)=> {
            const el = this.container.find("input[name=" + name + "]");
            if (el.length > 0) {
                const value = el.val();
                if (value === "") {
                    return true;
                }
            }
            return false;
        };

        const showError = (name)=> {
            const el = this.container.find("input[name=" + name + "]");
            if (el.length > 0) {
                const error = el.val();
                pageHelper.showErrors(error);
            }
        };

        const action = this.container.find("input[name=uploadAction]:checked").val();
        if (action === "uploadImage") {
            if (isEmpty("Files") && isInsertAction()) {
                showError("FilesError");
                return false;
            }
        }
        else if (action === "url") {
            if (isEmpty("Url")) {
                showError("UrlError");
                return false;
            }
        }
        else if (action === "copyImage") {
            if (isEmpty("ImageSelected")) {
                showError("ImageSelectedError");
                return false;
            }
        }
        return true;
    }
}

//const instance = new Image();
//export default instance;
